import Flow from 'types/Flow';
import { SelfServiceSteps } from 'modules/selfServices/types/SelfServiceSteps';

import {
  BREAKDOWN_INFO, CUSTOMER_INFO, KIOSK_USAGE, PARKING, QUESTIONS, EXTRAS, BASKET
} from '../onSite';

export type CommonKioskBreakdownSteps =
  SelfServiceSteps.CUSTOMER_INFO
  | SelfServiceSteps.BREAKDOWN_INFO
  | SelfServiceSteps.EXTRAS
  | SelfServiceSteps.BASKET
  | SelfServiceSteps.QUESTIONS
  | SelfServiceSteps.KIOSK_USAGE
  | SelfServiceSteps.PARKING;

export const COMMON_KIOSK_BREAKDOWN_STEPS: Flow<CommonKioskBreakdownSteps> = {
  CUSTOMER_INFO,
  BREAKDOWN_INFO,
  EXTRAS,
  QUESTIONS,
  KIOSK_USAGE,
  PARKING,
  BASKET,
};
